import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Avatar, Box } from "@mui/material";
import { TrackWebappEvent } from "@/modules/segment-event-tracking/segmentEventTracking";
import { EventTrackName } from "@/modules/segment-event-tracking/constant";
import { useSelector } from "react-redux";

export default function RecommendScreenSizePopup({ screenSize, open, setOpen }) {
  const { userTrackInfoPayload } = useSelector((state) => state.jobs);
  const [prevWidth, setPrevWidth] = React.useState(screenSize.width);

  const handleClickOpen = () => {
    TrackWebappEvent(`${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._load_webapp_mobile}`,userTrackInfoPayload);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (screenSize.width < process.env.NEXT_PUBLIC_SCREEN_SIZE_ALERT && prevWidth >= process.env.NEXT_PUBLIC_SCREEN_SIZE_ALERT) handleClickOpen();
    else if (screenSize.width >= process.env.NEXT_PUBLIC_SCREEN_SIZE_ALERT) handleClose();
    setPrevWidth(screenSize.width);
  }, [screenSize]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: "200px",
            width: "fit-content",
            maxWidth: "350px",
            gap: "20px",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              cursor: "pointer",
            }}
            onClick={() => setOpen(false)}
          >
            <img src="/images/cancel.svg" alt="" width="18px" />
          </Box>
          <Box sx={{background:"#e5e5e5",borderRadius:"50%",p:"10px"}}>
          <Avatar src="/images/round-laptop.png" alt="" sx={{width:"22px",height:"22px"}} />
          </Box>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ textAlign: "center", color: "#262626" }}
          >
            For better experience, we recommend opening the link on a desktop
            device.
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}
